<template>
  <div>
    <b-form-file v-model="file" ref="file-input" class="teste"></b-form-file>
    <b>{{ file ? file.name : '' }}</b>
  </div>
</template>

<script>
import fileUploaderPrice from './fileUploaderPrice'
export default fileUploaderPrice

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/pricetablemanagement/components/fileUploaderPrice/fileUploaderPrice.vue